import CompareList from './CompareList'

export default CompareList
